import { marked } from 'marked';

// Prevent version-like strings (e.g. test@1.2.3, pkg@0.2.26-beta) from being
// auto-linked as emails. Only suppress when the part after @ lacks a valid TLD
// (2+ consecutive alpha chars after the last dot).
marked.use({
  tokenizer: {
    url(src) {
      const emailMatch = /^[A-Za-z0-9._+-]+@([^\s<]+)/.exec(src);
      if (emailMatch) {
        const domain = emailMatch[1];
        const lastDot = domain.lastIndexOf('.');
        const tld = lastDot >= 0 ? domain.slice(lastDot + 1) : '';
        if (!/^[a-zA-Z]{2,}$/.test(tld)) {
          return {
            type: 'text',
            raw: src.split(/[\s<]/)[0],
            text: src.split(/[\s<]/)[0],
          } as any;
        }
      }
      return false as any;
    },
  },
});

marked.use({
  extensions: [
    {
      name: 'colorOpen',
      level: 'inline',
      start(src) {
        return src.indexOf('{color:');
      },
      tokenizer(src) {
        const match = /^\{color:([^}]+)\}/.exec(src);

        if (!match) return;

        return {
          type: 'colorOpen',
          raw: match[0],
          color: match[1],
        };
      },
      renderer(token) {
        return `<span style="color:${token.color}">`;
      },
    },
    {
      name: 'colorClose',
      level: 'inline',
      start(src) {
        return src.indexOf('{color}');
      },
      tokenizer(src) {
        const match = /^\{color\}/.exec(src);

        if (!match) return;

        return {
          type: 'colorClose',
          raw: match[0],
        };
      },
      renderer() {
        return '</span>';
      },
    },
    {
      name: 'markOpen',
      level: 'inline',
      start(src) {
        return src.indexOf('{mark:');
      },
      tokenizer(src) {
        const match = /^\{mark:([^}]+)\}/.exec(src);

        if (!match) return;

        return {
          type: 'markOpen',
          raw: match[0],
          color: match[1],
        };
      },
      renderer(token) {
        return `<mark style="background-color:${token.color}">`;
      },
    },
    {
      name: 'markClose',
      level: 'inline',
      start(src) {
        return src.indexOf('{mark}');
      },
      tokenizer(src) {
        const match = /^\{mark\}/.exec(src);

        if (!match) return;

        return {
          type: 'markClose',
          raw: match[0],
        };
      },
      renderer() {
        return '</mark>';
      },
    },
  ],
});
